import { z } from 'zod'
import { ACCOUNT_ERROR_CODES } from './accounts.ts'
import { CABINET_ERROR_CODES } from './cabinets.ts'
import { GAME_ERROR_CODES } from './games.ts'
import { NOT_FOUND_ERROR_CODES } from './notFound.ts'
import { TENANT_ERROR_CODES } from './tenants.ts'

export * from './configIssues.ts'
export * from './notFound.ts'

/**
 * Every code the admin API and the auth routes send besides oRPC's own
 * (`errorCode` in an error's `data`; Better Auth's in its body's `code`).
 * The panel translates `errors.<code>` and falls back to the English
 * `message`, so a code the panel does not know yet still reads.
 */
export const ADMIN_ERROR_CODES = [
  ...NOT_FOUND_ERROR_CODES,
  ...TENANT_ERROR_CODES,
  ...ACCOUNT_ERROR_CODES,
  ...GAME_ERROR_CODES,
  ...CABINET_ERROR_CODES,
] as const

export type AdminErrorCode = (typeof ADMIN_ERROR_CODES)[number]

/** A value a text can name: numbers and words, never user data in a sentence's grammar. */
export const errorParamsSchema = z.record(
  z.string(),
  z.union([z.string(), z.number()]),
)

export type ErrorParams = z.infer<typeof errorParamsSchema>

/**
 * What an API error adds to its `data`, next to whatever else it carries
 * (`issues`). Both optional and additive: `errorCode` is a plain string on
 * the wire so a client older than the backend still parses an unknown one.
 */
export const errorDetailSchema = z.object({
  errorCode: z.string().optional(),
  params: errorParamsSchema.optional(),
})

export type ErrorDetail = z.infer<typeof errorDetailSchema>
